// extracted by mini-css-extract-plugin
export var container = "_dj-0";
export var infoIcon = "_dj-2";
export var titleRowCol = "_dj-1";